export default __webpack_public_path__ + "static/media/separator.0da2ee28.svg";